import { createSlice } from "@reduxjs/toolkit";

const initialCollectionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  collectionForEdit: undefined,
  collection: undefined,
  lastError: null,
  page: 0,
  totalPages: 0,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const categorySlice = createSlice({
  name: "categories",
  initialState: initialCollectionsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCollectionById
    collectionFetched: (state, action) => {
      state.actionsLoading = false;
      state.collectionForEdit = action.payload.collection;
      state.collection = action.payload.collection;
      state.error = null;
    },
    // findCollections
    collectionsFetched: (state, action) => {
      const { totalCount, entities, page, totalPages } = action.payload;

      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.page = page;
      state.totalPages = totalPages;
    },
    clearCategories: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = [];
      state.collectionForEdit = undefined;
      state.collection = undefined;
      state.lastError = null;
      state.page = 0;
      state.totalPages = 0;
    },
    categoryFetched: (state, action) => {
      const { totalCount, entities, page, totalPages } = action.payload;

      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.page = page;
      state.totalPages = totalPages;
    },
    // createCollection
    collectionCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.collection);
    },
    // updateCollection
    collectionUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.collection.id) {
          return action.payload.collection;
        }
        return entity;
      });
    },
    // deleteCollection
    collectionDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    // deleteCollections
    collectionsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => !action.payload.ids.includes(el.id)
      );
    },
    // collectionsUpdateState
    collectionsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
  },
});
